
export class MortageRateCategory {
  // The category of rates this belongs to - special, basic
  rateCategory: string;

  subCategories: MortgageRateSubCategory[] = [];

  public getRates(): MortgageRate[] {
    let rates = [];
    this.subCategories.forEach((r) => {
      rates = rates.concat(r.rates);
    });
    return rates;
  }
}

export class MortgageRateSubCategory {
  // Offer name
  name: string;

  rates: MortgageRate[] = [];
}

export class MortgageRate {
  // how long is it for
  term: string;

  // Detailed name of the rate
  name: string;

  rate: string;

}

